export default () => {
    return {
        show: false,
        animating: false,
        ministryAnimating: false,
        ministryHover: false,
        ministryHovered: 'foundation',
        closeEverything: false,

        init() {
            TweenMax.set(this.$refs.menuBase01, { yPercent: 101, opacity: 1 })
            TweenMax.set(this.$refs.menuBase02, { yPercent: 101, opacity: 1 })
            TweenMax.set(this.$refs.redline, { yPercent: 101, opacity: 1 })

            this.$watch('$store.navigator.ministry', value => (value ? this.openMinistries() : this.closeMinistries()))
            this.$watch('$store.navigator.open', value => (value ? this.open() : this.close()))
        },

        animationFinisher() {
            this.$store.navigator.animating = false
        },

        open() {
            document.body.classList.add('h-full', 'overflow-hidden')
            this.show = true

            const openMenu = new TimelineMax({
                onComplete: () => {
                    this.animationFinisher()
                },
            })

            openMenu
                .fromTo(this.$refs.menuBase01, 0.8, { yPercent: 101 }, { yPercent: 0, ease: Circ.easeInOut })

                .fromTo(
                    this.$refs.menuBase02,
                    0.8,
                    { yPercent: 101 },
                    { yPercent: 0, delay: -0.5, ease: Circ.easeInOut },
                )

                .to(this.$refs.menuWrapper, 0.3, { autoAlpha: 1 })

            openMenu
                .fromTo(this.$refs.redline, 0.6, { yPercent: 101 }, { yPercent: 0, delay: -0.8, ease: Circ.easeInOut })
                .to(this.$refs.footer, 0.3, { autoAlpha: 1 })
                .to(this.$refs.button, 0.3, { autoAlpha: 1 })
        },

        close() {
            const closeMenu = new TimelineMax({
                onComplete: () => {
                    document.body.classList.remove('h-full', 'overflow-hidden')
                    this.show = false
                    this.animationFinisher()
                },
            })

            closeMenu
                .addLabel('start')
                .to(this.$refs.button, 0.3, { autoAlpha: 0 })
                .to(this.$refs.footer, 0.3, { autoAlpha: 0 }, 'start')
                .to(this.$refs.menuWrapper, 0.3, { autoAlpha: 0 }, 'start')

            closeMenu
                .to(this.$refs.redline, 0.6, { yPercent: -104, ease: Circ.easeInOut }, 'start+=0.1')
                .to(this.$refs.menuBase02, 0.7, { yPercent: -104, ease: Circ.easeInOut }, 'start+=0.3')
                .to(this.$refs.menuBase01, 0.6, { yPercent: -104, ease: Circ.easeInOut }, 'start+=0.5')
        },
    }
}
